import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgModule, ApplicationRef } from '@angular/core';
 import { BrowserModule } from '@angular/platform-browser';
 import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  // MatAutocompleteModule,
  MatButtonModule,
  // MatButtonToggleModule,
  // MatCardModule,
  // MatCheckboxModule,
  // MatChipsModule,
  // MatDatepickerModule,
  // MatDialogModule,
   MatExpansionModule,
   MatTableModule,
  // MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  // MatMenuModule,
  // MatNativeDateModule,
  // MatPaginatorModule,
  // MatProgressBarModule,
  MatProgressSpinnerModule,
  // MatRadioModule,
  // MatRippleModule,
  MatSelectModule,
  MatFormFieldModule,
  // MatSidenavModule,
  // MatSliderModule,
  MatSlideToggleModule,
  // MatSnackBarModule,
  // MatSortModule,
  // MatTabsModule,
  // MatToolbarModule,
  // MatTooltipModule,
  // MatStepperModule,
  // MAT_DATE_LOCALE,
  // MAT_DATE_FORMATS,
  // DateAdapter,
  // MAT_NATIVE_DATE_FORMATS,
  // MatPaginatorIntl
} from '@angular/material';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// Layout
import { LayoutComponent } from './layout/layout.component';
import { PreloaderDirective } from './layout/preloader.directive';
// Header
import { AppHeaderComponent } from './layout/header/header.component';
// Sidenav
import { AppSidenavComponent } from './layout/sidenav/sidenav.component';
import { ToggleOffcanvasNavDirective } from './layout/sidenav/toggle-offcanvas-nav.directive';
import { AutoCloseMobileNavDirective } from './layout/sidenav/auto-close-mobile-nav.directive';
import { AppSidenavMenuComponent } from './layout/sidenav/sidenav-menu/sidenav-menu.component';
import { AccordionNavDirective } from './layout/sidenav/sidenav-menu/accordion-nav.directive';
import { AppendSubmenuIconDirective } from './layout/sidenav/sidenav-menu/append-submenu-icon.directive';
import { HighlightActiveItemsDirective } from './layout/sidenav/sidenav-menu/highlight-active-items.directive';
// Customizer
import { AppCustomizerComponent } from './layout/customizer/customizer.component';
import { ToggleQuickviewDirective } from './layout/customizer/toggle-quickview.directive';
// Footer
import { AppFooterComponent } from './layout/footer/footer.component';
// Search Overaly
import { AppSearchOverlayComponent } from './layout/search-overlay/search-overlay.component';
import { SearchOverlayDirective } from './layout/search-overlay/search-overlay.directive';
import { OpenSearchOverlaylDirective } from './layout/search-overlay/open-search-overlay.directive';

// Pages
import { DashboardComponent } from './dashboard/dashboard.component';
// import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';

// Sub modules
import { LayoutModule } from './layout/layout.module';
// import { SharedModule } from './shared/shared.module';

// hmr
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';
// import { DataService } from './utils/data.service';
// import { modalComponent } from './utils/modal/modal.component';
// import { MomentDateAdapter, MOMENT_DATE_FORMATS } from './moment-date-adapter';
import { LoginComponent } from './login/login.component';
import { LoginGuard } from './login/login.guard';
import { NoLoginGuard } from './login/no-login.guard';
import { ModalTicketComponent } from './pago-venta/modal-ticket/modal-ticket.component';
import { GridColumnDataPipe } from './utils/custom-grid/grid-column-data.pipe';
// import { PersonalEliminarComponent } from './personal/consultar-eliminar/personal-eliminar.component';
// import { FamiliarAddEditComponent } from './familiar/agregar-editar/familiarAddEdit.component';
// import { CotizacionAddEditComponent } from './cliente/cotizacion/agregar-editar/cotizacionAddEdit.component';
// import { BitacoraAddEditComponent } from './personal/bitacora/agregar-editar/bitacora-addedit.component';
// import { BitacoraClienteAddEditComponent } from './cliente/bitacora/agregar-editar/bitacoraCliente-addedit.component';
// import { UbicacionAddEditComponent } from './cliente/ubicacion/agregar-editar/ubicacion-addedit.component';
// import { getESPaginatorIntl } from './es-paginator-intl';
// import { ClienteSaeComponent } from './cliente-sae/cliente-sae.component';
// import { ClienteSaeAgregarEditarComponent } from './cliente-sae/cliente-sae-agregar-editar/cliente-sae-agregar-editar.component';
// import { PagoVentaComponent } from './pago-venta/pago-venta.component';
// import { PagoVentaService } from './pago-venta/pago-venta.service';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DatePipe } from '@angular/common';
// import { NotaCargoConsultarComponent } from './nota-cargo/consultar-eliminar/nota-cargo-consultar.component';
// import { NotaCargoDescargarComponent } from './nota-cargo/consultar-eliminar/nota-cargo-descargar.component';
// import { NotaCargoEliminarComponent } from './nota-cargo/consultar-eliminar/nota-cargo-eliminar.component';
// import { NotaCargoDetalleComponent } from './nota-cargo/agregar-editar/nota-cargo-detalle.component';


import {CdkTableModule} from '@angular/cdk/table';

@NgModule({
  imports: [
    NgxChartsModule,
    CdkTableModule,
     BrowserModule,
    HttpModule,
    FormsModule,
    BrowserAnimationsModule,
    // MatAutocompleteModule,
    MatButtonModule,
    // MatButtonToggleModule,
    // MatCardModule,
    // MatCheckboxModule,
    // MatChipsModule,
    // MatStepperModule,
    // MatDatepickerModule,
    // MatDialogModule,
     MatExpansionModule,
    // MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatListModule,
    // MatMenuModule,
    // MatNativeDateModule,
    // MatPaginatorModule,
    // MatProgressBarModule,
    MatProgressSpinnerModule,
    // MatRadioModule,
    // MatRippleModule,
    MatSelectModule,
    // MatSidenavModule,
    // MatSliderModule,
    MatSlideToggleModule,
    // MatSnackBarModule,
    // MatTableModule,
     // MatSortModule,
    // MatTabsModule,
    // MatToolbarModule,
    // MatTooltipModule,
    AppRoutingModule,

    // Sub modules
    LayoutModule,
    // SharedModule,

    // Date range Picker
    NgxDaterangepickerMd.forRoot({
      format: 'DD/MM/YYYY',
      separator: ' - ',
      cancelLabel: 'Cancelar',
      applyLabel: 'Aplicar',
      customRangeLabel: 'Seleccionar rango',
      firstDay: 1 // first day is monday
    })
  ],
  declarations: [
    AppComponent,
    // Layout
    LayoutComponent,
    PreloaderDirective,
    // Header
    AppHeaderComponent,
    // Sidenav
    AppSidenavComponent,
    ToggleOffcanvasNavDirective,
    AutoCloseMobileNavDirective,
    AppSidenavMenuComponent,
    AccordionNavDirective,
    AppendSubmenuIconDirective,
    HighlightActiveItemsDirective,
    // Customizer
    AppCustomizerComponent,
    ToggleQuickviewDirective,
    // Footer
    AppFooterComponent,
    // Search overlay
    AppSearchOverlayComponent,
    SearchOverlayDirective,
    OpenSearchOverlaylDirective,
    //
    DashboardComponent,
    LoginComponent,
    ModalTicketComponent,
    
    // Pages
    // PageLayoutFullscreenComponent,
    // modalComponent
   
  ],
  entryComponents: [
    ModalTicketComponent,
    // modalComponent,
    // PersonalEliminarComponent,
    // FamiliarAddEditComponent,
    // CotizacionAddEditComponent,
    // BitacoraAddEditComponent,
    // BitacoraClienteAddEditComponent,
    // UbicacionAddEditComponent
   
  ],
  providers: [
    // DataService,
    LoginGuard,
    NoLoginGuard,
    DatePipe,
    // PagoVentaService,
    // { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    // { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    // { provide: DateAdapter, useClass: MomentDateAdapter },
    // { provide: MatPaginatorIntl, useValue: getESPaginatorIntl() }
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts